import { faEllipsisVAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { AddToolTip, FormControlSearch } from "../../../components";

const PassthroughUnmappedField = (props) => {
  const {
    data,
    setShowSlideOut,
    index,
    setFieldIndex,
    setFieldOrder,
    isRequiredPassthrough,
  } = props;
  return (
    <div className="mb-3">
      <div
        className={`d-flex targetDropable ${
          data?.isConfiguration == false &&
          isRequiredPassthrough &&
          "border border-danger"
        }`}
      >
        <div className="drop-icons align-self-center">
          <FontAwesomeIcon icon={faEllipsisVAlt} size="1x" color="#BDBDBD" />
          <FontAwesomeIcon icon={faEllipsisVAlt} size="1x" color="#BDBDBD" />
        </div>
        <p
          className="grey-text ft-14 ml-2"
          style={{ display: "flex", margin: "2px", alignSelf: "center" }}
        >
          Drop here or
          <div
            //   onClick={() => {
            //     if (!isOutput) setshowSlideout(true);
            //   }}
            style={{ textDecoration: "none", cursor: "pointer" }}
            to="/home"
          >
            <span
              style={{ color: "#2F80ED", margin: "2px" }}
              onClick={() => {
                setShowSlideOut(true);
                setFieldIndex(index);
                setFieldOrder(data?.order);
              }}
            >
              {" "}
              {" " + "Click to Configure"}
            </span>
          </div>
        </p>
      </div>
    </div>
  );
};

export default PassthroughUnmappedField;
